"use client"; // Error boundaries must be Client Components

import { useEffect } from "react";

// Catches unexpected runtime errors in any /tools route segment so a thrown server fetch shows
// a recoverable fallback instead of leaving the page stuck.
interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ToolsError({ error, reset }: Props) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main id="main-content" tabIndex={-1}>
      <section className="py-section-sm">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="border-destructive/40 bg-destructive/10 max-w-3xl rounded-lg border px-5 py-4">
            <h2 className="light:text-red-700 text-sm font-semibold text-red-300">
              Something went wrong
            </h2>
            <p className="text-muted-foreground light:text-foreground/80 mt-1 text-sm">
              {error.message || "An unexpected error occurred while loading this page."}
            </p>
            <button
              type="button"
              onClick={() => reset()}
              className="bg-brand-green text-background mt-4 rounded-lg px-4 py-2 text-sm font-semibold transition-opacity hover:opacity-90"
            >
              Try again
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}
